import { close } from './toggleHandler';
import * as crossTabSync from './crossTabSync';

let boundHandler = null;

function endChat({ broadcastSyncEvent = true } = {}) {
  close();
  document.dispatchEvent(new CustomEvent('chatkit.end-chat'));
  if (broadcastSyncEvent) crossTabSync.broadcast('chatkit.sync.end-chat');
}

export function setup() {
  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const endChatButton = container.querySelector('.chatkit-end-chat-btn');

  boundHandler = () => endChat();

  if (endChatButton) endChatButton.addEventListener('click', boundHandler);

  document.addEventListener('chatkit.sync.end-chat', () => endChat({ broadcastSyncEvent: false }));
}

export function cleanup() {
  const container = document.getElementById('chatkit-widget-container');

  if (container && boundHandler) {
    const endChatButton = container.querySelector('.chatkit-end-chat-btn');
    if (endChatButton) endChatButton.removeEventListener('click', boundHandler);
  }

  boundHandler = null;
}
